export default {
  pdkComponents: {
    count: 0,
    results: []
  },
  kenComponents: {
    count: 0,
    results: []
  },
  getComponets: [],
  getComponetsByGroup: [],
  groupComponents: [], // Группы компонентов
  ecologyType: [],
  measurmentUnits: [],
  subordination: [],
  ownership: [],
  activityField: [],
  departments: [],
  sourceParameters: [],
  objectsParameters: [],
  ministry: [],
  dangerCategories: [1, 2, 3, 4, "0"],

  //REGIONS
  parentRegions: [],
  childRegions: [],
  allRegions: []
};
